import { MODULE_URLS, URLS } from '../config/constants';

export const getMaintenanceCookieId = startTime => `learner_maintenance_${startTime}`;

export const isImpersonatedSession = (auth = {}) =>
  auth.delegation?.delegated && auth.delegation?.type === 'USER_IMPERSONATION';

export const isInsideRevQ = pathname => pathname.startsWith(URLS.REVQ);

export const isRIScorecardAccessible = (companySettings = {}) =>
  companySettings.sciEnabled && companySettings.showRiForLS;

export const isInsideAnalytics = pathname => pathname.startsWith(URLS.ANALYTICS);
export const showBackToHomeButton = pathname => isInsideAnalytics(pathname);
export const showLearnerBadge = pathname => isInsideAnalytics(pathname);

export const isCoachingUrl = pathname => pathname.startsWith(MODULE_URLS.coaching);
export const isReinforcementUrl = pathname => pathname.startsWith(MODULE_URLS.reinforcement);
export const isChecklist = pathname => pathname.startsWith(MODULE_URLS.checklist);

export const DEVICE_TYPE = {
  MOBILE: 'Mobile',
  TABLET: 'Tablet',
  DESKTOP: 'Desktop',
};

// eslint-disable-next-line complexity
export const getDeviceType = () => {
  const width =
    window?.innerWidth || document?.documentElement?.clientWidth || document?.body?.clientWidth;
  const userAgent = navigator?.userAgent;

  return /mobile/i.test(userAgent) || width < 768
    ? DEVICE_TYPE.MOBILE
    : /tablet|iPad|Nexus 7|Nexus 10/i.test(userAgent) || (width >= 768 && width < 1024)
    ? DEVICE_TYPE.TABLET
    : DEVICE_TYPE.DESKTOP;
};
